import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './lib/icons'
import './styles/index.css'
import { App } from './App'

// FontAwesome SVG core: 자동 CSS 삽입 비활성 → 우리 CSP 친화
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false

const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
